

























import Vue from "vue";
import Component from "vue-class-component";
import { State, Action, Mutation } from "vuex-class";
import { FacebookState } from "../../../store/facebook";

const namespace = "facebook";

@Component
export default class Account extends Vue {
  @State("facebook") facebook: FacebookState;
  @Mutation("addError", { namespace }) addError: any;
  @Mutation("removeError", { namespace }) removeError: any;
}

// export default Vue.extend({
//   data(): { errors: Array<string> } {
//     return { errors: [] };
//   },
//   methods: {
//     addError(error: string) {
//       this.errors.push(error);
//     },
//     removeError(i: number) {
//       this.errors = this.errors.filter((e, ii) => i != ii);
//     }
//   }
// });
